// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/CTA.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/CTA.tsx");
  import.meta.hot.lastModified = "1732036225877.8174";
}
// REMIX HMR END

import Button from "./Button";
import Heading from "./Heading";
/**
 * Renders a CTA block with title, text and a button styled accordingly to the selected variant.
 * 
 * @param title The title of the section. 
 * @param text The relevant text to show in the section.
 * @param cta CTA object with the button contents.
 * @param size The size of the whole section.
 * 
 * @returns A CTA section component.
 * 
 */

export default function CTA({
  text,
  title,
  cta,
  size = "large"
}) {
  const ctaSize = {
    small: {
      boxStyles: "flex flex-col gap-4 rounded-lg bg-neutral-100 p-6",
      titleStyles: "",
      textStyles: "text-neutral-600 text-base",
      buttonStyles: {
        size: "sm",
        variant: "primary"
      }
    },
    large: {
      boxStyles: "flex flex-col items-center gap-4 w-full",
      titleStyles: "text-center",
      textStyles: "text-neutral-600 text-center max-w-[60ch] text-lg",
      buttonStyles: {
        size: "base",
        variant: "tertiary"
      }
    }
  };
  const {
    boxStyles,
    buttonStyles,
    textStyles,
    titleStyles
  } = ctaSize[size];
  return <section className={boxStyles}>
        <Heading tag="h2" className={titleStyles}>
            {title}
        </Heading>
        <div dangerouslySetInnerHTML={{
      __html: text?.processed
    }} className={textStyles} />
        <div className="flex flex-row justify-center gap-4">
            {cta?.map(cta => <Button to={cta.url ? cta.url : "/"} variant={buttonStyles.variant} key={cta.title} size={buttonStyles.size}>
                    {cta.title}
                </Button>)}
        </div>
    </section>;
}
_c = CTA;
var _c;
$RefreshReg$(_c, "CTA");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;